import React,{createContext, useState} from "react";


interface Company {
    id: number;
    companyName: string;

}

export interface Freight {
    id: number;
    type: string;
    deadLine: string;
    readyToShip: string;
    status: string;
    companyId: number;
    addressId?: number | null;
    routeId: number | null;
    Company: {
        id: number;
        companyName: string;
    };
    Address?: {
        id: number;
        street: string;
        number: string;
        complement: string;
        cep: number;
        Neighborhood: {
            name: string;
            City: {
                name: string;
                State: {
                    name: string;
                    uf: string;
                };
            };
        };
    } | null;
    route: null;
    Load: {
        id: number;
        height: string;
        width: string;
        length: string;
        cubage: string;
        weight: string;
        detail: string;
        freightId: number;
    };
    observation?: string;
    orderNumber?: string;
    CreatedByUser?: { name: string } | null;
    createdAt?: string;
    UpdatedByUser?: { name: string } | null;
    updatedAt?: string;
}

interface Vehicle {
    id: number;
    plate: string;
    model: string;
    year: number;
    capacity: string;
    restriction: string;
    size: string;
}
export interface Router {
    id: number;
    Vehicle: {
        id: number;
        plate: string;
        model: string;
        year: number;
        capacity: string;
        restriction: string;
        size: string;
    };
    url: string;
    date: string;
    status: string;
    origin: string;
    track: string;
    companyDestination?: boolean;
    Freight: Freight[];
    responsible: string;
    CreatedByUser?: { name: string } | null;
    createdAt?: string;
    UpdatedByUser?: { name: string } | null;
    updatedAt?: string;
}

interface RouterContextProps {
    router: Router | null,
    setRouter: React.Dispatch<React.SetStateAction<Router|null>>
}

export const RouterContext = createContext<RouterContextProps>({
    router: {
        id: 0,
        Vehicle: {
            id: 0,
            plate: '',
            model: '',
            year: 0,
            capacity: '',
            restriction: '',
            size: ''
        },
        url: '',
        date: '',
        status: '',
        origin: '',
        track: '',
        companyDestination: true,
        Freight: [],
        responsible: ''
    },
  setRouter: () => {}
});


export const RouterProvider: React.FC<any>= ({children})=>{
    
    const [router, setRouter] = useState<Router|null>(null);

    return(
        <RouterContext.Provider value={{router, setRouter}}>
            {children}
        </RouterContext.Provider>
    )
}